import './QueryModal.css';
import React, { useState } from 'react';

import successImg from './../../assets/img/successImg.svg';
const SuccessModal = (props) => {
  return (
    <div>
      {props.message == 'SUCCESS' && props.requestType == 'QUERY' && (
        <section className="modal-main1" style={{ borderTop: '5px solid green', height: '40%' }}>
          <div>
            <div>
              <img src={successImg} className="simg" width="70" height="70" />
            </div>
            <label className="smsg" style={{ marginTop: '20px', textAlign: 'center' }}>
              Your questions have been submitted successfully.
              <br />
              Please allow 24-48 hrs to receive responses.
              {/* {props.message} */}
            </label>
          </div>
        </section>
      )}

      {props.message == 'FAIL' && (
        <section
          className="modal-main1"
          style={{ borderTop: '5px solid red', width: '300px', height: '200px' }}
        >
          <div>
            {/* <div><img src={successImg} className="simg"  width="70" height="70" /></div> */}
            <label
              className="smsg"
              style={{ marginTop: '20px', color: 'red', textAlign: 'center' }}
            >
              The application has encountered an error. Pleaser try again later!
              {/* {props.message} */}
            </label>
          </div>
        </section>
      )}

      {props.message == 'SUCCESS' && props.requestType == 'TOUR' && (
        <section className="modal-main1" style={{ borderTop: '5px solid green' }}>
          <div>
            <div>
              <img src={successImg} className="simg" width="70" height="70" />
            </div>
            <label className="smsg" style={{ marginTop: '20px', textAlign: 'center' }}>
              A Tour has been successfully requested.
              <br />
              Our flexpert team will soon connect with you.
              {/* {props.message} */}
            </label>
          </div>
        </section>
      )}

      {props.message == 'SUCCESS' && props.requestType == 'PROPOSAL' && (
        <section className="modal-main1" style={{ borderTop: '5px solid green' }}>
          <div>
            <div>
              <img src={successImg} className="simg" width="70" height="70" />
            </div>
            <label className="smsg" style={{ marginTop: '20px', textAlign: 'center' }}>
              An Agreement has been successfully requested.
              <br />
              Our flexpert team will soon connect with you.
              {/* {props.message} */}
            </label>
          </div>
        </section>
      )}
    </div>
  );
};

export default SuccessModal;
